export * from './properties-wrapper';